export default class SectionStart {
	constructor(ScrollTrigger, scrollTo) {

		// ТОЛЬКО ДЛЯ DESKTOP
		if (!window.isMobile(window.navigator).any) {

			// ПЕРЕХОД (вниз) к #section-gallery
			ScrollTrigger.create({
				onEnter: () => {
					scrollTo.goToSection('#section-gallery', 1)
					history.replaceState(null, null, '#exhibit-desc-1');
				},
			});

			// ПЕРЕХОД (вверх) к #section-start
			ScrollTrigger.create({
				trigger: '#section-start',
				onEnterBack: () => {
					scrollTo.goToSection('#section-start', -1)
					setTimeout(() => {
						history.replaceState(null, null, ' ');
					}, 300);
				},
				// markers: true
			});

		}

		// КНОПКА (вниз) перехода к #section-gallery
		document.getElementById('scroll-to-section-gallery').onclick = () => {
			scrollTo.goToSection('#section-gallery', 1)
			history.replaceState(null, null, '#exhibit-desc-1');
		}

		// ИКОНКИ "мышь/палец"		
		let orientationNow = 0;
		let supportScreenOrientation = true;
		const orientationCallback = (orientation) => {
			orientationNow = orientation;
			ScrollTrigger.refresh()
		}

		if (!window.screen || !window.screen.orientation) {
			supportScreenOrientation = false;
		}

		if (supportScreenOrientation) {
			orientationNow = window.screen.orientation.angle;
			window.screen.orientation.addEventListener(
				"change",
				() => {
					orientationCallback(window.screen.orientation.angle)
				}
			);
		} else {
			orientationNow = window.orientation;
			window.orientationchange = () => {
				orientationCallback(window.orientation)
			};
		}

		const checkOrientation = () => {
			return (orientationNow % 180 == 0);
		}
		
		window.addEventListener("preloader:hidden", () => {
			let orientationGap = !checkOrientation() ? 100 : 50;
			let gap = window.matchMedia("(max-width: 1024px)").matches ? orientationGap : 0;
			ScrollTrigger.create({
				trigger: 'body',
				pin: '#scroll-mouse-icon',
				start: `top+=${gap} top`,
				end: `100%-=${window.innerHeight + gap}px bottom`,
				onRefresh: (e) => {
					let orientationGap = !checkOrientation() ? 100 : 50;
					let gap = window.matchMedia("(max-width: 1024px)").matches ? orientationGap : 0;
					e.vars.start = `top+=${gap}px top`;
					e.vars.end = `100%-=${window.innerHeight + gap}px bottom`;
				},
				// markers: true
			});
		});
	}
}